
import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col } from 'react-bootstrap';
import productbanner from '../Assets/food/25.jpg';
import '../Assets/WebsiteCss/product.css';
import { Helmet } from "react-helmet";


import sohanpapadi from '../Assets/food/sonpapdi.jpg'
import alubhujiya from '../Assets/food/aloo_bhujia.jpg'
import dryfruitmix from '../Assets/food/dryfruits.webp'
import chanamasala from '../Assets/food/chaana.webp'
import indori from '../Assets/food/indori.webp'
import fariyalisabudana from '../Assets/Image/FariyaliSabudana.png'
import gujaratimix from '../Assets/Image/Gujaratimix.png'
import moongdal from '../Assets/food/moong_dal.webp'
import nadiyadimix  from '../Assets/food/NadiyadiMixture.jpg'
import chidchidpapdi  from '../Assets/food/chidchidpapdi.png'
import kashmirimix from '../Assets/food/KashmiriMix.webp'
import ratlamisev from '../Assets/food/RatlamiSev.webp'
import ujainisev from '../Assets/food/ujjainShev.jpg'
import palakbesansev from '../Assets/food/palakpudinasev.webp'
import masallachidchidpapdi from '../Assets/Image/MasalaChidchdpapadi.png'
import sabudanakhichadi from '../Assets/food/Sabudanakhichdi.jpg'
import hingumasalasev from '../Assets/food/heeng-mixture.jpg'
import tamatarbesansev from '../Assets/food/TamatarShev.jpg'
import lasansev from '../Assets/food/lasanSev.jpg'
import bhavnagrisev from '../Assets/food/bhavnagri_gathiya.webp'
import farilimitha from '../Assets/Image/fariyarimix.png'
import Fariyalicharka from '../Assets/food/lal-fariyali-mixture.jpeg'
import gujaratipapdi from '../Assets/food/papdi.webp'
import stargathiya from '../Assets/food/Star Gathiya.jpg'
import charkibundi from '../Assets/food/charkhi-boondi.webp'
import fikibundi from '../Assets/food/fikkiBundhi.jpg'
import panjabimix from '../Assets/food/punjabimixture.webp'
import alubhavabhujiya from '../Assets/Image/alubhavabhujiya.png'
import masalachanadal from '../Assets/food/MasalaChanaDal.jpg'
import podinadal from '../Assets/food/podinaDal.webp'
import hingmix from '../Assets/Image/hingmix.png'
import milkcake from '../Assets/food/MilkCake.webp';
import malaichamcham from '../Assets/food/MalaiChamcham.webp';
import dryfruitcake from '../Assets/food/DryFruitTea.webp';
import malairoll from '../Assets/food/Bread-Malai-Roll.jpg';
import anjeerkatli from '../Assets/food/AnjirKajuKatli.jpg';
import anjeerroll from '../Assets/food/kajuAnjeerRoll.jpg';
import chips from '../Assets/food/chips.png';

export default function Products() {
  useEffect(() => {
        AOS.init({ duration: 1000, once: true });
      }, []);

  const products = [
    { name: "Moong Daal (Masala)", image: moongdal },
    { name: "Nadiyadi Mix", image: nadiyadimix },
    { name: "Chid Chid Papdi", image: chidchidpapdi },
    { name: "Kashmiri Mix", image: kashmirimix },
    { name: "Ratlami Sev", image: ratlamisev },
    { name: "Ujaini Sev", image: ujainisev },
    { name: "Palak Besan Sev", image: palakbesansev },
    { name: "Masala Chid Chid Papdi", image: masallachidchidpapdi },
     { name: "Sohan Papdi", image:sohanpapadi },
    { name: "Alu Bhujiya", image: alubhujiya},
    { name: "Dry Fruit Mix", image: dryfruitmix },
    { name: "Chana Jor Masala", image: chanamasala },
    { name: "Indori Khatta Mitha", image: indori },
    { name: "Fariyali Sabudana", image: fariyalisabudana },
    { name: "Gujarati Papdi", image: gujaratipapdi },
    { name: "Start Gathiya", image: stargathiya },
    { name: "Charki Bundi ", image: charkibundi },
    { name: "Fiki Bundi", image: fikibundi },
    { name: "Panjabi Mix", image: panjabimix },
    { name: "Fariyali Sabudana Khichdi", image: sabudanakhichadi },
    { name: "Hingu Masala Sev", image: hingumasalasev },
    { name: "Tamatar Besan Sev", image: tamatarbesansev },
    { name: "Lasan Sev", image: lasansev },
    { name: "Bhavnagri Gathiya", image: bhavnagrisev },
    { name: "Fariyali Mitha Mix", image: farilimitha },
    { name: "Fariyali Charka Mix", image: Fariyalicharka },
    { name: " Chips", image: chips },
    { name: "Hing Mix", image: hingmix },
    { name: "Alu Bhava Bhujiya", image: alubhavabhujiya },
    { name: "Masala Chana Dal", image: masalachanadal },
    { name: "Podina Dal", image: podinadal },
      { name: "Milk Cake ", image: milkcake },
  { name: "Malai Chamcham ", image: malaichamcham },
  { name: "Dry Fruit Cake ", image: dryfruitcake },
  { name: "Malai Roll ", image: malairoll },
  { name: "Anjeer Katli ", image: anjeerkatli },
  { name: "Anjeer King Roll ", image: anjeerroll },
];
 


  return (
    <>
      <div className="mainnav min-vh-100">
      <Helmet>
        {/* Page Title */}
        <title>Namkeen Collection | Karigar India Namkeen Labour Contractor</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Explore Karigar India's Namkeen Collection – 200+ handcrafted varieties including Bhujia, Sev, Chivda, Moong Daal, Alu Bhujiya, Sohan Papdi, Dry Fruit Mix, and more. Crafted with 15+ years of experience by Bhojmal Salvi, delivering authentic taste across India."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Karigar India, Namkeen Collection, Bhujia, Sev, Chivda, Moong Daal, Alu Bhujiya, Sohan Papdi, Dry Fruit Mix, Fariyali Sabudana, Indori Khatta Mitha, Handcrafted Snacks, Indian Namkeen, Traditional Namkeen, Snacks Supplier"
        />

        {/* Author */}
        <meta name="author" content="Karigar India" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Namkeen Collection | Karigar India Namkeen Labour Contractor" />
        <meta property="og:description" content="Discover 200+ handcrafted namkeen varieties from Karigar India, including Bhujia, Sev, Chivda, and sweets. Expertly made by Bhojmal Salvi with 15+ years of experience." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.karigarindia.in/products" />
        <meta property="og:image" content="https://www.karigarindia.in/logo.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Namkeen Collection | Karigar India Namkeen Labour Contractor" />
        <meta name="twitter:description" content="Explore 200+ delicious handcrafted namkeen varieties including Bhujia, Sev, Chivda, Moong Daal, Alu Bhujiya, and more, delivered across India by Karigar India." />
        <meta name="twitter:image" content="https://www.karigarindia.in/logo.png" />

        {/* Favicon */}
        <link rel="icon" href="/logo.png" />
      </Helmet>
        
        {/* Banner */}
        <div className="service-container ">
          <img src={productbanner} alt="" className="servicenamkken img-fluid" />
          <div className="service-overlay"></div>
          <div className="service-text" >Where Tradition Meets Taste – Explore Our Namkeen Collection</div>
        </div>

        {/* Product Intro */}
        <Container className="py-3">
          <div className="text-center mb-4">
            <h2 className="middletext mb-3" data-aos="zoom-in">
              Discover the Delicious World of Our Namkeen
            </h2>
            <p className="text-muted">
              Discover 200+ delicious namkeen varieties handcrafted by Bhojmal Salvi with 15+ years of experience. From crispy snacks to flavorful mixtures, we bring authentic taste to every corner of India.
            </p>
          </div>

      <Row className='m-0'>
  {products.map((product, index) => (
    <Col md={3} sm={6} xs={6} key={index} className="mb-4 ">
      <div className="productser-card shadow-sm ">
        <img src={product.image} alt={product.name} className="productser-img" />
        <div className="productser-overlay">
          {product.name}
        </div>
      </div>
    </Col>
  ))}
</Row>

        </Container>
      <section className="gallery-section py-5">
      <Container>
       <div className="text-center mb-4">
            <h2 className="middletext mb-3" data-aos="zoom-in">
          Watch Our Work in Action (Our Gallery)
        </h2>
        </div>
<Row className="gx-4 gy-2 justify-content-center">

  {/* Video 1 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="100">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/PrH5MK4hs-4"
        title="YouTube Shorts Video 1"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 2 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="200">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/6Mvhcukfk3M"
        title="YouTube Shorts Video 2"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 3 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="300">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/qF1oK0ZVm-8"
        title="YouTube Shorts Video 3"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 4 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="400">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/HmULBbZga6Q"
        title="YouTube Shorts Video 4"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 5 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="500">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/N3RHDQX2zsU"
        title="YouTube Shorts Video 5"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 6 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="600">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
  src="https://www.youtube.com/embed/BzadYC_iDNk"
  title="YouTube Shorts Video 6"
  allowFullScreen
  style={{ width: "100%", height: "90%", borderRadius: "12px", border: "none" }}
></iframe>

    </div>
  </Col>

   <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="600">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
  src="https://www.youtube.com/embed/mVzssX5VLEE"
  title="YouTube Shorts Video 7"
  allowFullScreen
  style={{ width: "100%", height: "90%", borderRadius: "12px", border: "none" }}
></iframe>


    </div>
  </Col>
</Row>


      </Container>
    </section>
      </div>
    </>
  );
}
